import type { UseFormRegister, UseFormRegisterReturn } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { SampleFormData } from '../../utils/sampleFormSchema';
import { joinLabeledValue } from '../../utils/joinLabeledValue';
import { SampleFormSectionTitle } from './SampleFormSectionTitle';

interface SampleFormDrawerFieldsProps {
  register: UseFormRegister<SampleFormData>;
  drawerNumberRegister: UseFormRegisterReturn;
}

/** サンプル登録・編集の引き出し / ケース欄 */
export default function SampleFormDrawerFields({
  register,
  drawerNumberRegister,
}: SampleFormDrawerFieldsProps) {
  const { t } = useTranslation();

  return (
    <div className="sample-form-section">
      <SampleFormSectionTitle icon="fa-inbox">
        {t('sample.drawer_information')}
      </SampleFormSectionTitle>
      <div className="row">
        <Form.Group className="mb-3 col-md-4">
          <Form.Label htmlFor="sample-drawer-number" title={t('sample.drawer_number')}>
            {t('sample.drawer_short', { defaultValue: '引き出し' })}
          </Form.Label>
          <Form.Control
            id="sample-drawer-number"
            type="number"
            min="0"
            {...drawerNumberRegister}
            autoComplete="off"
          />
        </Form.Group>
        <Form.Group className="mb-3 col-md-4">
          <Form.Label htmlFor="sample-case-name">{t('sample.case')}</Form.Label>
          <Form.Control
            id="sample-case-name"
            name="caseName"
            type="text"
            {...register('caseName')}
            placeholder={joinLabeledValue(t('sample.case'), t('sample.optional'))}
            title={joinLabeledValue(t('sample.case'), t('sample.optional'))}
            autoComplete="off"
          />
        </Form.Group>
        <Form.Group className="mb-3 col-md-4">
          <Form.Label htmlFor="sample-drawer-note">{t('sample.drawer_note')}</Form.Label>
          <Form.Control
            id="sample-drawer-note"
            name="drawerNote"
            type="text"
            {...register('drawerNote')}
            placeholder={joinLabeledValue(t('sample.drawer_note'), t('sample.optional'))}
            title={joinLabeledValue(t('sample.drawer_note'), t('sample.optional'))}
            autoComplete="off"
          />
        </Form.Group>
      </div>
    </div>
  );
}
